import { render } from "./InvoiceItemRowComponent.vue?vue&type=template&id=b1d181fc&scoped=true"
import script from "./InvoiceItemRowComponent.vue?vue&type=script&lang=js"
export * from "./InvoiceItemRowComponent.vue?vue&type=script&lang=js"

import "./InvoiceItemRowComponent.vue?vue&type=style&index=0&id=b1d181fc&scoped=true&lang=css"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d181fc"]])

export default __exports__